import React, { useState, useEffect } from 'react'
import { Paper, Divider, Card } from '@mui/material'
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, Scrollbar, Autoplay } from 'swiper';
import 'swiper/css/autoplay';
import 'swiper/css';
import api from '../../API/api';
import BlurCircularIcon from '@mui/icons-material/BlurCircular';



const AlumniHighlight = () => {

    const [alumni, setAlumni] = useState();

    useEffect(() => {
        getAlumni()
    }, []);

    const getAlumni = () => {
        api.getAlumni().then((res) => {
            // console.log(res);
            setAlumni(res.data.data)
        })
    }

    return (
        <>
            <div className='my-2'>
                <Paper elevation={3}>
                    <div className='p-5'>

                        <div className="text-center">
                            <h2> Placement Highlights </h2>
                        </div>
                        <div className='text-center pb-4'>
                            <i> <small> <BlurCircularIcon fontSize='small' /> Impressive job placements for the students  <BlurCircularIcon fontSize='small' /> High placement percentage and success rate <BlurCircularIcon fontSize='small' /> Build a successful future with PEWS</small></i>
                        </div>


                        <div className="row p-2">
                            <div className="col-12">
                                <div>
                                    <Swiper
                                        // slidesPerView={3}
                                        // pagination={{ clickable: true }}
                                        spaceBetween={5}
                                        autoplay={true}
                                        loop={true}

                                        modules={[Autoplay, Pagination, Navigation, Scrollbar]}

                                        breakpoints={{
                                            // when window width is >= 640px
                                            460: {
                                                //   width: 640,
                                                slidesPerView: 2,
                                            },
                                            // when window width is >= 768px
                                            768: {
                                                //   width: 768,
                                                slidesPerView: 3,
                                            },
                                            968: {
                                                //   width: 768,
                                                slidesPerView: 5,
                                            },

                                        }}
                                    >



                                        {alumni && alumni.map((a) =>
                                        (
                                            <>
                                                {a.highlights === 1 &&
                                                    <SwiperSlide>
                                                        <div className="p-1">
                                                            <Paper elevation={5} sx={{ borderRadius: '0%', minHeight: '250px' }} >
                                                                <div className='text-center p-2 d-flex justify-content-center align-items-center' style={{ height: '300px', overflow: 'hidden' }}>
                                                                    {a.photo ?
                                                                        <img src={`${process.env.REACT_APP_BACKEND}assets/alumni/${a.photo}`} className='col-12'  alt='pews alumni'/>
                                                                        :
                                                                        <img src="./assets/default.png" className='col-12' alt='pews alumni' />
                                                                    }


                                                                </div>
                                                                <hr className='m-0' />
                                                                <div className="m-2 p-2 text-center" style={{ minHeight: '150px' }}>
                                                                    <div className=''> <b> {a.name}</b> </div>
                                                                    <div className=''> <small> {a.course} ({a.batch})</small></div>
                                                                    <div className=''> <b> {a.placedAt} </b></div>
                                                                    <div className=''> {a.designation && <small>({a.designation})  </small>}</div>

                                                                </div>
                                                            </Paper>
                                                        </div>
                                                    </SwiperSlide>
                                                }
                                            </>
                                        )
                                        )}


                                    </Swiper>
                                </div>
                            </div>
                        </div>

                    </div>
                </Paper>
            </div>
        </>
    )
}

export default AlumniHighlight;